import reqEnum from '../../utils/request-statuses';

export const getGoals = state => state.goals.goals;
export const goalsStatus = state => state.goals.status;
export const goalsLoadingInProgress = state => state.goals.status === reqEnum.loading;
export const goalsError = state => state.goals.error;
export const getPager = state => state.goals.pager;